import { UtilHelper } from '../../../shared/helpers/utils.helper';
import { Table } from '../../store/models/table-list.model';
import { OrderStatus } from '../../orders/enums/order-status.enum';
import { Order } from '../../orders/models/order.model';

export class CustomerPayment {
	customerId: number;
	customerName: string;
	totalPayment: number;
	ordersCount?: number;
	orderStatus?: OrderStatus; // Quando existir mais de 1 pedido, trazer o primeiro na ordem de produção (Na fila (0), em produção (1), Entregue (3)

	// usado para controle por usuário
	orders?: Array<Order>;
	orderStatusDescription?: string;

	constructor(obj: any = { }) {
		Object.assign(this, obj);
	}
}

export class TablesPaymentList {
	sector: string;
	list: Array<TablePayment>;

	constructor(obj: any = { }) {
		Object.assign(this, obj);
	}
}

export class TablePayment {
	table: Table;
	pendingPayments: Array<CustomerPayment>;

	constructor(obj: any = { }) {
		Object.assign(this, obj);

		if (this.pendingPayments && this.pendingPayments.length > 0) {
			this.pendingPayments.forEach((t: CustomerPayment) => {
				t.orderStatus = UtilHelper.getEnumByCod(t.orderStatus, OrderStatus);
			});
		}
	}
}



// WEBPACK FOOTER //
// ./src/app/pages/tables-payment/models/table-payment.model.ts